import { Grid, Typography } from "@mui/material";
import { utils } from "../../../../../utils/utils";

const Info = ({ description, highlight, color, ingress, egress, total, view = 'Acciones', diff }) => {
    return (
        <Grid container spacing={1}>
            <Grid size={2}>
                <Typography color='primary' variant={highlight ? 'h6' : 'subtitle1'} component='p' style={{ textTransform: 'uppercase' }}>
                    <strong>{description}</strong>
                </Typography>
            </Grid>
            <Grid size="grow">
                <Grid container justifyContent="flex-end" spacing={1}>
                    {
                        (ingress || ingress === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{utils.formatMoney(ingress)}</strong> : utils.formatMoney(ingress)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (egress || egress === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{utils.formatMoney(egress)}</strong> : utils.formatMoney(egress)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (total || total === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{utils.formatMoney(total)}</strong> : utils.formatMoney(total)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (diff || diff === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{utils.formatMoney(diff)}</strong> : utils.formatMoney(diff)}
                            </Typography>
                        </Grid>
                    }
                </Grid>
            </Grid>
            <Grid size={2}>
                <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                    {highlight ? <strong>{view}</strong> : {view}}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default Info;